import React from "react";
import { serviceData } from "../../utils/WelcomeData";

const GOLD = "#ffc000";
const PRIMARY = "#000c66";

const CalendarIcon = () => (
  <svg viewBox="0 0 24 24" width={16} height={16} fill={GOLD}>
    <path d="M19 4h-1V2h-2v2H8V2H6v2H5C3.9 4 3 4.9 3 6v14a2 2 0 002 2h14a2 2 0 002-2V6a2 2 0 00-2-2zm0 16H5V9h14v11zM7 11h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2z" />
  </svg>
);

export const Services = () => (
  <section
    style={{ background: "#f8f7f3", position: "relative", overflow: "hidden" }}
  >
    {/* Faint cross watermark */}
    <svg
      style={{
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        opacity: 0.04,
        pointerEvents: "none",
      }}
      width={480}
      height={480}
      viewBox="0 0 200 200"
      fill={PRIMARY}
    >
      <rect x="88" y="10" width="24" height="180" rx="4" />
      <rect x="10" y="68" width="180" height="24" rx="4" />
      <circle cx="100" cy="100" r="94" stroke={PRIMARY} strokeWidth="1" fill="none" strokeDasharray="6 6" />
    </svg>

    <div
      className="mx-auto px-4 py-16 md:py-24"
      style={{ maxWidth: 1200, position: "relative", zIndex: 1 }}
    >
      {/* Header */}
      <div className="flex flex-col items-center text-center mb-12">
        <div className="flex items-center gap-3 mb-4">
          <div className="h-px w-8" style={{ background: `${GOLD}88` }} />
          <p
            className="font-abel uppercase tracking-[0.4em] text-xs"
            style={{ color: GOLD }}
          >
            Schedule
          </p>
          <div className="h-px w-8" style={{ background: `${GOLD}88` }} />
        </div>

        <h2
          className="font-aref font-bold leading-tight"
          style={{
            color: PRIMARY,
            fontSize: "clamp(1.75rem, 3.5vw, 2.8rem)",
          }}
        >
          Church <span style={{ color: GOLD }}>Services</span>
        </h2>

        <div className="my-5 flex items-center gap-3" style={{ width: 200 }}>
          <div className="flex-1 h-px" style={{ background: `${GOLD}55` }} />
          <svg viewBox="0 0 24 24" width={12} height={12} fill={GOLD}>
            <path d="M9 0h6v7h9v6h-9v11H9V13H0V7h9z" />
          </svg>
          <div className="flex-1 h-px" style={{ background: `${GOLD}55` }} />
        </div>

        <p
          className="font-abel text-base"
          style={{ color: "#888", maxWidth: 460 }}
        >
          Our weekly services commence as listed below — all are welcome to
          attend and experience God's presence.
        </p>
      </div>

      {/* Cards grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(210px, 1fr))",
          gap: 16,
        }}
      >
        {serviceData.map((service) => (
          <div
            key={service.id}
            style={{
              background: "#fff",
              border: `1px solid ${GOLD}33`,
              borderTop: `3px solid ${GOLD}`,
              borderRadius: 8,
              padding: "18px 16px",
              display: "flex",
              flexDirection: "column",
              gap: 6,
              boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
              transition: "transform 0.2s ease, box-shadow 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-4px)";
              e.currentTarget.style.boxShadow = `0 10px 28px ${GOLD}22`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 2px 12px rgba(0,0,0,0.05)";
            }}
          >
            <div className="flex items-center justify-between mb-1">
              <span
                className="font-aref font-bold text-sm"
                style={{ color: PRIMARY }}
              >
                {service.title}
              </span>
              <CalendarIcon />
            </div>

            <p
              className="font-abel font-semibold"
              style={{ color: "#333", fontSize: 14, lineHeight: 1.4 }}
            >
              {service.text}
            </p>

            <div className="flex items-center gap-1.5 mt-2">
              <div
                style={{
                  width: 5,
                  height: 5,
                  borderRadius: "50%",
                  background: GOLD,
                  flexShrink: 0,
                }}
              />
              <span
                className="font-abel text-xs"
                style={{ color: "#aaa" }}
              >
                {service.time}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
